import { render } from "./MenuPermissionManagement.vue?vue&type=template&id=b7fff826&scoped=true"
import script from "./MenuPermissionManagement.vue?vue&type=script&lang=js"
export * from "./MenuPermissionManagement.vue?vue&type=script&lang=js"

import "./MenuPermissionManagement.vue?vue&type=style&index=0&id=b7fff826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7fff826"]])

export default __exports__